import { useEffect, forwardRef, useImperativeHandle } from 'react';
import { useMedicalRecordsSearch } from '../hooks';
import { InputSearch } from '@repo/atomic-components';

export type SearchTextControlHandle = {
  reset: () => void;
};

export const SearchTextControl = forwardRef<SearchTextControlHandle, unknown>((_props, ref) => {
  const { searchInputRef, handleResetClick, handleSearchInputKeyDown } = useMedicalRecordsSearch();

  // Forward imperative reset to InputSearch
  useImperativeHandle(
    ref,
    () => ({
      reset: () => searchInputRef.current?.reset(),
    }),
    [searchInputRef],
  );

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'f') {
        event.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex w-full flex-row gap-2">
      <InputSearch
        ref={searchInputRef}
        type="text"
        placeholder="Search by document or case reference"
        onKeyDown={handleSearchInputKeyDown}
        onClear={handleResetClick}
        isLoading={false}
      />
    </div>
  );
});

// Allow usage without ref
SearchTextControl.displayName = 'SearchTextControl';
